import React from "react";
var __jsx = React.createElement;
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { createPortal } from "react-dom";
var FLowFixedContainer = function FLowFixedContainer(_ref) {
  var children = _ref.children;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col fixed bottom-0 px-4 gap-2 pb-6 pt-4 w-full left-0 md:relative md:!mt-[200px] md:max-w-[340px] md:mx-auto md:gap-5 bg-white rounded-tl-2xl rounded-tr-2xl"
  }, children)), document.body)), /*#__PURE__*/React.createElement(Else, null, children)));
};
export default FLowFixedContainer;